import { OESTRA_QUIZ_ENTRY_HREF } from "~/constants/oestraLandingPages";
import Nad from "@/icons/products/product-nad-white.svg";
import Bodymatched from "@/icons/products/body-matched.svg";
import Oestra from "@/icons/products/product-oestra-r.svg";
import LibidaWhite from "@/icons/products/product-libida-white-new.svg";
import { QUIZ_ROUTES } from "~/constants/quizRoutes";
import { APP_ROUTES } from "~/constants/appRoutes";

export const PRODUCTS = [
    {
        imageTitle: "Is your hormonal imbalance trying to tell you something?",
        desktopImageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790100948/new_design/Frame_2087328398_hthds3.webp",
        mobileImageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790100947/new_design/Frame_2147205725_yqvouv.webp",
        title: "Is your hormonal imbalance trying to tell you something?",
        description: <>Oestra<sup>®</sup> supports estrogen balance through perimenopause and beyond — helping regulate mood, energy, sleep, and cycles.</>,
        logo: <Oestra width="200" height="41" />,
        cta: {
            label: "Explore Oestra®",
            href: OESTRA_QUIZ_ENTRY_HREF,
        },
        analyticEvent: {
            click_text: "Explore Oestra®",
            product_name: "oestra",
        }
    },
    {
        imageTitle: "What if desire started in the brain, not just the body?",
        desktopImageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790611594/new_design/Libida_ejdtxv.webp",
        mobileImageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790611594/new_design/Libida_mob_iv2wgq.webp",
        title: "What if desire started in the brain, not just the body?",
        description: <>Libida activates the neural pathways <br className="md:hidden" />of <br className="hidden md:block" />arousal with added oxytocin — <br className="md:hidden" />supporting <br className="hidden md:block" />desire, intimacy, and <br className="md:hidden" />connection at the source.</>,
        logo: <LibidaWhite width={154} height={44} />,
        cta: {
            label: "Explore Libida®",
            href: QUIZ_ROUTES.LIBIDA,
        },
        analyticEvent: {
            click_text: "Explore Libida®",
            product_name: "libida",
        },
    },
    {
        imageTitle: "What if aging skin was a signal — not a flaw?",
        desktopImageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790100950/new_design/Frame_2087328399_q5cw6j.webp",
        mobileImageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790100947/new_design/Frame_2147205724_1_ghy1co.webp",
        title: <>What if aging skin was a <br className="md:hidden" />signal — not a flaw?</>,
        description: <>Our anti-aging face <br className="md:hidden" />cream supports cellular <br className="md:hidden" />renewal and barrier <br className="md:hidden" />repair, restoring <br className="md:hidden" />resilience, hydration, <br className="md:hidden" />and glow over time.</>,
        logo: <Bodymatched width={278} height={42} />,
        cta: {
            label: "Explore BodyMatched®",
            href: APP_ROUTES.PQP_ANTI_AGING_FACE_CREAM,
        },
        analyticEvent: {
            click_text: "Explore BodyMatched®",
            product_name: "anti-aging face cream",
        },
        contentCn: "text-primary500",
    },
    {
        imageTitle: "What if aging started at the cellular level, not just the surface?",
        desktopImageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790100949/new_design/Frame_2087328401_k9llb9.webp",
        mobileImageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790100947/new_design/Frame_2147205726_jqkh6o.webp",
        title: "What if aging started at the cellular level, not just the surface?",
        description: <>NAD+ replenishes the <br className="md:hidden" />coenzyme your cells depend on <br className="md:hidden" />— supporting energy, DNA repair, <br className="md:hidden" />and healthy aging from within.</>,
        logo: <Nad className="w-[167px] md:w-[196px]" />,
        cta: {
            label: "Explore NAD+",
            href: QUIZ_ROUTES.NAD,
        },
        analyticEvent: {
            click_text: "Explore NAD+",
            product_name: "nad+",
        }
    }
];

export const RECOMMENDATIONS = [
    {
        title: "Endometriosis",
        productName: "oestra",
        description: "Oestra® for pain resolution",
        className: "bg-gradient-slate-blue-soft",
        link: OESTRA_QUIZ_ENTRY_HREF
    },
    {
        title: "Skin Longevity",
        productName: "anti-aging face cream",
        description: "Bodymatched® for skin restoration",
        className: "bg-gradient-navy-blue-soft",
        link: APP_ROUTES.PQP_ANTI_AGING_FACE_CREAM,
    },
    {
        title: "Cellular Vitality",
        productName: "nad+",
        description: "NAD+ for cellular energy and renewal",
        className: "bg-gradient-slate-green",
        link: QUIZ_ROUTES.NAD
    },
    {
        title: "General HRT",
        productName: "oestra",
        description: "Oestra® for hormonal balance",
        className: "bg-gradient-slate-blue-soft",
        link: OESTRA_QUIZ_ENTRY_HREF
    },
    {
        title: "Intimacy & Closeness",
        productName: "libida",
        description: "Libida® for improved connection",
        className: "bg-gradient-indigo-blue",
        link: QUIZ_ROUTES.LIBIDA
    },
    {
        title: "Perimenopause",
        productName: "oestra",
        description: "Oestra® for symptom relief",
        className: "bg-gradient-slate-blue-soft",
        link: OESTRA_QUIZ_ENTRY_HREF
    },
    {
        title: "Facial Hair + Oil Control",
        productName: "anti-aging face cream",
        description: "Bodymatched® for optimal skin health",
        className: "bg-gradient-navy-blue-soft",
        link: APP_ROUTES.PQP_ANTI_AGING_FACE_CREAM,
    },
    {
        title: "Metabolism Support",
        productName: "nad+",
        description: "NAD+ for long-term cellular vitality",
        className: "bg-gradient-slate-green",
        link: QUIZ_ROUTES.NAD
    },
    {
        title: "Menopause",
        productName: "oestra",
        description: "Oestra®for menopause symptom relief",
        className: "bg-gradient-slate-blue-soft",
        link: OESTRA_QUIZ_ENTRY_HREF
    },
    {
        title: "Desire & Sexual Interest",
        productName: "libida",
        description: "Libida® for increased arousal",
        className: "bg-gradient-indigo-blue",
        link: QUIZ_ROUTES.LIBIDA
    },
    {
        title: "Postpartum",
        productName: "oestra",
        description: "Oestra® for mood and anxiety relief",
        className: "bg-gradient-slate-blue-soft",
        link: OESTRA_QUIZ_ENTRY_HREF
    },
    {
        title: "Longevity Support",
        productName: "nad+",
        description: "NAD+ for long-term cellular health",
        className: "bg-gradient-slate-green",
        link: QUIZ_ROUTES.NAD
    },
    {
        title: "PCOS",
        productName: "oestra",
        description: "Oestra® for better energy, mood & comfort",
        className: "bg-gradient-slate-blue-soft",
        link: OESTRA_QUIZ_ENTRY_HREF
    },
];
